// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h2[data-v-67b400f9]{margin:0 0 1rem}h2[data-v-67b400f9],h2 a[data-v-67b400f9]{color:inherit}h2 a[data-v-67b400f9]{font-family:\"Open Sans Condensed\",sans-serif;font-size:1.5rem;font-weight:300;line-height:1.8rem}ul[data-v-67b400f9]{list-style-type:none;padding-left:0}ul[data-v-67b400f9],ul li[data-v-67b400f9],ul li a[data-v-67b400f9]{color:inherit}ul li a[data-v-67b400f9]{font-size:.85rem;line-height:1.8rem}a[data-v-67b400f9]:hover{color:#00a2d2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
